import React, { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function NavbarComponent() {
  const [scrollState, setScrollState] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      var scrolled = document.scrollingElement.scrollTop;
      if (scrolled >= 120) {
        setScrollState(false);
      } else {
        setScrollState(true);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const linkClass = scrollState ? "nav-link" : "nav-link dark";
  const close = () => setExpanded(false);

  // Smooth scroll to an in-page section (works from any route)
  const scrollTo = (e, id) => {
    e.preventDefault();
    close();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <Navbar
      fixed="top"
      expanded={expanded}
      onToggle={(next) => setExpanded(next)}
      className={scrollState ? "navbar-dark gw-nav" : "navbar-primary gw-nav"}
      expand="lg"
    >
      <Navbar.Brand>
        <Link className={linkClass} to="/" onClick={close}>
          GoWave{" "}
          <span style={{ color: scrollState ? "#63FFCD" : "#0a1a12", fontWeight: 600 }}>
            Automation Lab
          </span>
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
        <Nav>
          <a href="/#home" className={linkClass} onClick={(e) => scrollTo(e, "home")}>
            Home
          </a>
          <a href="/#services" className={linkClass} onClick={(e) => scrollTo(e, "services")}>
            Services
          </a>
          <a href="/#products" className={linkClass} onClick={(e) => scrollTo(e, "products")}>
            Products
          </a>
          <Link to="/portfolio" className={linkClass} onClick={close}>
            Portfolio
          </Link>
          <a href="/#contact" className={linkClass} onClick={(e) => scrollTo(e, "contact")}>
            Contact
          </a>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
